import React from "react"
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby';

const HomeHero = () => {

  return (
<div className="bg-white py-24 sm:py-32">
  <div className="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">
    <h1 className="mt-2 text-center mx-auto max-w-2xl text-pretty text-5xl font-bold text-gray-950 sm:text-6xl">The Status Page That Fits Your Workflow</h1>
    <p className="mt-4 mx-auto max-w-xl text-center text-pretty leading-normal text-2xl text-gray-600 sm:text-xl/8">Sorry™ gives you the instant status page communication tool that you need.</p>
    <div className="mt-10 grid grid-cols-1 gap-4 sm:mt-16 lg:grid-cols-6 lg:grid-rows-2">
      <Link to="/public-status-page/" className="relative lg:col-span-3">
        <div className="absolute inset-px rounded-lg bg-white max-lg:rounded-t-[2rem] lg:rounded-tl-[2rem]"></div>
        <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-t-[calc(2rem+1px)] lg:rounded-tl-[calc(2rem+1px)] hover:shadow-lg transition-shadow ease-in-out duration-300 hover:ring-gray-700">
          <StaticImage 
          className="h-80 object-cover" 
          src="../../images/homepage/public_status_page.png" 
          alt="Public Status Page"
          imgStyle={{ objectPosition: 'left' }}
          />
          <div className="p-10 pt-12">
            <h3 className="text-sm/4 font-semibold text-brand-600">Public Status Page</h3>
            <p className="mt-2 text-lg font-medium tracking-tight text-gray-950">Status pages that build trust</p>
            <p className="mt-2 max-w-lg text-sm/6 text-gray-600">Helping teams provide timely updates and information to customers builds long-term loyalty.</p>
          </div>
        </div>
        <div className="pointer-events-none absolute inset-px rounded-lg ring-1 ring-gray-200 max-lg:rounded-t-[2rem] lg:rounded-tl-[2rem]"></div>
      </Link>
      <Link to="/private-status-page/" className="relative lg:col-span-3">
        <div className="absolute inset-px rounded-lg bg-white lg:rounded-tr-[2rem]"></div>
        <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-tr-[calc(2rem+1px)] hover:shadow-lg transition-shadow ease-in-out duration-300">
        <StaticImage 
        className="h-80 object-cover" 
        src="../../images/homepage/private_status_page.png" 
        alt="Private Status Page"
        imgStyle={{ objectPosition: 'left' }}
        />
          <div className="p-10 pt-12">
            <h3 className="text-sm/4 font-semibold text-brand-600">Private Status Pages</h3>
            <p className="mt-2 text-lg font-medium tracking-tight text-gray-950">Instant internal awareness</p>
            <p className="mt-2 max-w-lg text-sm/6 text-gray-600">Bring teams together about upcoming maintenance and on-going incidents, without overloading inboxes.</p>
          </div>
        </div>
        <div className="pointer-events-none absolute inset-px rounded-lg ring-1 ring-gray-200 lg:rounded-tr-[2rem]"></div>
      </Link>
      <Link to="/notices/incidents/" className="relative lg:col-span-2">
        <div className="absolute inset-px rounded-lg bg-white lg:rounded-bl-[2rem]"></div>
        <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-bl-[calc(2rem+1px)] hover:shadow-lg transition-shadow ease-in-out duration-300">
        <StaticImage 
          src="../../images/homepage/incident_statuses.png" 
          alt="Incident Notices"
          className="h-80 object-cover"
          imgStyle={{ objectPosition: 'left' }}
        />
          <div className="p-10 pt-8">
            <h3 className="text-sm/4 font-semibold text-brand-600">Incidents</h3>
            <p className="mt-2 text-lg font-medium tracking-tight text-gray-950">Fast and accurate incident communication</p>
            <p className="mt-2 max-w-lg text-sm/6 text-gray-600">Keeping customers informed promptly and accurately during incidents is critical for maintaining trust and reducing frustration.</p>
          </div>
        </div>
        <div className="pointer-events-none absolute inset-px rounded-lg ring-1 ring-gray-200 lg:rounded-bl-[2rem]"></div>
      </Link>
      <Link to="/notices/general/" className="relative lg:col-span-2">
        <div className="absolute inset-px rounded-lg bg-white"></div>
        <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] hover:shadow-lg transition-shadow ease-in-out duration-300">
          <StaticImage 
          className="h-80 object-cover" 
          src="../../images/homepage/card_changelog.png" 
          alt="General Notices" 
          imgStyle={{ objectPosition: 'left' }}
          />
          <div className="p-10 pt-8">
            <h3 className="text-sm/4 font-semibold text-brand-600">Changelog</h3>
            <p className="mt-2 text-lg font-medium tracking-tight text-gray-950">Communicate changes, fixes & announcements.</p>
            <p className="mt-2 max-w-lg text-sm/6 text-gray-600">Using general notices builds loyalty and engages users, which is crucial for long-term success.</p>
          </div>
        </div>
        <div className="pointer-events-none absolute inset-px rounded-lg ring-1 ring-gray-200"></div>
      </Link>
      <Link to="/notices/maintenance/" className="relative lg:col-span-2">
        <div className="absolute inset-px rounded-lg bg-white max-lg:rounded-b-[2rem] lg:rounded-br-[2rem]"></div>
        <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-b-[calc(2rem+1px)] lg:rounded-br-[calc(2rem+1px)] hover:shadow-lg transition-shadow ease-in-out duration-300">
          <StaticImage 
          className="h-80 object-cover" 
          src="../../images/homepage/maintenance_statuses.png" 
          alt="Maintenance Notices" 
          imgStyle={{ objectPosition: 'left' }}
          />
          <div className="p-10 pt-8">
            <h3 className="text-sm/4 font-semibold text-brand-600">Maintenance</h3>
            <p className="mt-2 text-lg font-medium tracking-tight text-gray-950">Proactive maintenance <br/>communication</p>
            <p className="mt-2 max-w-lg text-sm/6 text-gray-600">Informing users ahead of time will significantly reduce the number of support inquiries and complaints during maintenance periods.</p>
          </div>
        </div>
        <div className="pointer-events-none absolute inset-px rounded-lg ring-1 ring-gray-200 max-lg:rounded-b-[2rem] lg:rounded-br-[2rem]"></div>
      </Link>
    </div>
  </div>
</div>

  )
}

export default HomeHero